/* import __COLOCATED_TEMPLATE__ from './search-results-item.hbs'; */
import Component from '@glimmer/component';
import clsx from 'clsx';
import { createCache, getValue } from '@glimmer/tracking/primitives/cache';

const METRIC_CLASS_NAME = 'people-center-my-network-search-results-item__activity__metric';

class SearchResultsItem extends Component {

  get inExtendedNetwork() {
    return !this.args.user.companySellerConnections.find(({ companyId }) => this.args.company.id == companyId);
  }

  #companySellerConnectionCache = createCache(() => {
    return this.args.user.companySellerConnections.find(({ companyId }) => this.args.company.id == companyId);
  });

  get companySellerConnection() {
    return getValue(this.#companySellerConnectionCache);
  }

  get mostRecentlyUpdatedActiveApplication() {
    const sortedActiveApplications = this.args.user.applications.toArray().sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
    return sortedActiveApplications[0];
  }

  get activeProjectsClasses() {
    return clsx(
      METRIC_CLASS_NAME,
      !this.activeProjects && `${METRIC_CLASS_NAME}--empty`
    );
  }

  get completedProjectsClasses() {
    return clsx(
      METRIC_CLASS_NAME,
      !this.completedProjects && `${METRIC_CLASS_NAME}--empty`
    );
  }

  get isActiveProjectsUnavailable() {
    return this.companySellerConnection?.activeProjects == null;
  }

  get isCompletedProjectsUnavailable() {
    return this.companySellerConnection?.completedProjects == null;
  }

  get activeProjects() {
    return this.companySellerConnection?.activeProjects ?? 0;
  }

  get activeProjectsText() {
    return `Active ${this.activeProjects > 1 ? 'projects' : 'project'}`;
  }

  get completedProjects() {
    return this.companySellerConnection?.completedProjects ?? 0;
  }

  get completedProjectsText() {
    return `Completed ${this.completedProjects > 1 ? 'projects' : 'project'}`;
  }

  get rating() {
    const rating = this.companySellerConnection?.rating;
    return rating ? rating.toFixed(1) : 0;
  }
}

export default SearchResultsItem;
